import { t } from "ttag";

import { FullscreenAlert, UserHeartRoundedIcon } from "@/shared/ui";

interface TreatmentDisqualificationProps {
  open: boolean;
  onGoBack: VoidFunction;
}

export const TreatmentDisqualification = ({
  open,
  onGoBack,
}: TreatmentDisqualificationProps) => {
  return (
    <FullscreenAlert.Root open={open}>
      <FullscreenAlert.Content theme="light">
        <FullscreenAlert.Header icon={UserHeartRoundedIcon}>
          <FullscreenAlert.Title>
            {t`It appears that LevelsRx treatments may not be the best fit for you at the moment`}
          </FullscreenAlert.Title>

          <FullscreenAlert.Description>
            {t`Based on your current selections, LevelsRx is unable to provide treatment at this time. You may go back and review or update your answers to continue. Please ensure that all information you provide is accurate.`}
          </FullscreenAlert.Description>
        </FullscreenAlert.Header>

        <FullscreenAlert.Footer>
          <FullscreenAlert.Action onClick={onGoBack}>
            {t`Back to Previous Step`}
          </FullscreenAlert.Action>
        </FullscreenAlert.Footer>
      </FullscreenAlert.Content>
    </FullscreenAlert.Root>
  );
};
